/* eslint-disable no-unused-vars */
import styled from 'styled-components';
export const Container = styled.div `
  margin: auto;
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
`;
